import { Element } from '@antv/g2';

/**
 * è·åå½åäºä»¶ç¸å³çå¾è¡¨åç´ 
 * @param context äº¤äºçä¸ä¸æ
 * @ignore
 */
export function getCurrentElement(context): Element | undefined {
  const event = context.event;
  let element;
  const target = event.target;
  if (target) {
    element = target.get('element');
  }
  return element;
}
